import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "leaveList",
  components: {
    MainLayout,
    Select2Multiple,
    flatPickr,
    Loading,
    AdvancedLaravelVuePaginate,
  },

  data() {
    return {
      CONFIG,
      leaveData: {},
      searchData: {
        teacher_name: null,
        from_date: null,
        to_date: null,
        request_date: null,
        status: null,
        leave_type: null,
        teacher_no: null
      },
      lastSearchParams: {},
      isLoading: false,
      search_status: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      leaveTypeOptions: [],
      leaveTypeToApprove: [],
      selected_leave_type: null,
      typeError: false,
      checkAll: false,
      unSelectedCb: [],
      nextPageCheckAll: false,
      selectedCb: [],
      searchSelectedCb: [],
      currentPage: 1,
      teacherName: '',
      fromDate: '',
      toDate: '',
      requestDate: '',
      status: '',
      leaveType: '',
      teacherNo: '',
    };
  },

  methods: {
    reset() {
      this.teacherName = '';
      this.requestDate = '';
      this.status = '';
      this.leaveType = '';
      this.fromDate = '';
      this.toDate = '';
      this.teacherNo = '';
      this.isLoading = true;
      this.search_status = false;
      this.searchData = {
        teacher_name: '',
        from_date: '',
        to_date: '',
        request_date: '',
        status: '',
        leave_type: '',
        teacher_no: ''
      };
      this.getLeave();
    },

    getLeave(page = 1) {
      this.isLoading = true;
      this.search_status = false;
      this.currentPage = page;

      axios.get('teacher/leave/list?page=' + page)
        .then(res => {
          this.leaveData = res.data;
          this.getLeaveTypeLists();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Teacher Leave List API Error", error);
        });
    },

    searchLeave(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      this.currentPage = page;

      const params = {
        teacher_name: this.searchData.teacher_name ? this.searchData.teacher_name.trim() : null,
        request_date: this.searchData.request_date,
        status: this.searchData.status,
        leave_type: this.searchData.leave_type,
        teacher_no: this.searchData.teacher_no,
        from_date: this.searchData.from_date,
        to_date: this.searchData.to_date
      };
      axios.get("teacher/leave/search?page=" + page, { params })
        .then(response => {
          this.leaveData = response.data;
          this.lastSearchParams = params;
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Teacher Leave Search API Error", error);
        });
    },

    confirmDelete(leaveId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.delete(leaveId);
      }
    },

    filter() {
      this.search_status = false;
      this.searchData.teacher_name = this.teacherName
      this.searchData.from_date = this.fromDate
      this.searchData.to_date = this.toDate
      this.searchData.request_date = this.requestDate
      this.searchData.status = this.status
      this.searchData.leave_type = this.leaveType
      this.searchData.teacher_no = this.teacherNo
      this.searchLeave();
    },

    delete(leaveId) {
      this.isLoading = true;

      axios.delete("teacher/leave/delete/" + leaveId)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Leave Deleted Successfully.", {
              timer: 3,
              position: "bottomCenter"
            });
            HandlePaginateService.afterDelete({
              listData: this.leaveData,
              currentPage: this.currentPage,
              isSearch: this.search_status,
              searchFn: this.searchLeave,
              listFn: this.getLeave
            });
          } else {
            this.$notification.error(res.data.error, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    showCreate() {
      this.$router.push({
        name: "teacherLeaveCreate",
      });
    },

    showEdit(leaveId) {
      this.$router.push({
        name: "teacherLeaveEdit",
        params: {
          id: leaveId
        }
      });
    },

    showDetail(leaveId) {
      this.$router.push({
        name: "teacherLeaveDetail",
        params: {
          id: leaveId
        }
      });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.searchLeave,
        listFn: this.getLeave
      })
    },

    excelDownload() {
      this.isLoading = true;
      axios.get('teacher/leave/excelDownload', {
        params: this.lastSearchParams,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `teacher_leave_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    async getLeaveTypeLists() {
      try {
        const res = await axios.get('leaveType/type-list');
        this.leaveTypeOptions = res.data
                                .map(item => {
                                  return {
                                    id: item.id,
                                    text: item.type
                                  }
                              });
        this.leaveTypeToApprove = res.data
                                .filter(item => item.type !== 'TBD')
                                .map(item => {
                                  return {
                                    id: item.id,
                                    text: item.type
                                  }
                              });
      } catch(error) {
        if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
      }
    },

    syncCurrentPageSelection() {
      const pageIds = this.leaveData.data
        .filter(leave => leave.status !== this.CONFIG.SHIFT_LEAVE_STATUS.APPROVE)
        .map(leave => leave.id);

      if (this.search_status) {
        this.searchSelectedCb = [...new Set([...this.searchSelectedCb, ...pageIds])];
      } else {
        this.selectedCb = [...new Set([...this.selectedCb, ...pageIds])];
      }
    },

    selectAll() {
      if (this.checkAll) {
        this.syncCurrentPageSelection();
        this.nextPageCheckAll = true;
      } else {
        this.selectedCb = [];
        this.searchSelectedCb = [];
        this.unSelectedCb = [];
        this.nextPageCheckAll = false;
      }
    },

    toggleSelection(e, leaveId) {
      const isChecked = e.target.checked;
      const checkableData = this.leaveData.data.filter(
          leave => leave.status !== this.CONFIG.SHIFT_LEAVE_STATUS.APPROVE
      );
      const totalCheckableOnPage = checkableData.length;

      if (!isChecked) {
        this.checkAll = false;
        this.searchSelectedCb = [];
        this.nextPageCheckAll = false;
        if (!this.unSelectedCb.includes(leaveId)) {
            this.unSelectedCb.push(leaveId);
        }
        this.selectedCb = this.selectedCb.filter(id => id !== leaveId);
        this.searchSelectedCb = this.searchSelectedCb.filter(id => id !== leaveId);
      } else {
          this.unSelectedCb = this.unSelectedCb.filter(id => id !== leaveId);
          if (this.search_status) {
              if (!this.searchSelectedCb.includes(leaveId)) this.searchSelectedCb.push(leaveId);
          } else {
              if (!this.selectedCb.includes(leaveId)) this.selectedCb.push(leaveId);
          }
      }

      if (!this.nextPageCheckAll) {
          const currentCount = this.search_status ? this.searchSelectedCb.length : this.selectedCb.length;
          this.checkAll = (currentCount === totalCheckableOnPage && totalCheckableOnPage > 0);
      } else {
          const currentlyUncheckedOnPage = checkableData.filter(item => 
              this.unSelectedCb.includes(item.id)
          ).length;

          this.checkAll = (currentlyUncheckedOnPage === 0);
      }
    },

    handleApprove() {
      let finalIds = this.search_status ? this.searchSelectedCb : this.selectedCb;
      if (finalIds.length === 0) {
        alert("Please select at least one leave request.");
        return;
      }
      this.$bvModal.show('modal-1');
    },

    submitBatchApprove() {
      if (!this.selected_leave_type) {
        this.typeError = true;
        return;
      }
      let finalIds = this.search_status ? this.searchSelectedCb : this.selectedCb;
      const payload = {
        ids: finalIds,
        leave_type_id: this.selected_leave_type
      };
      axios.post('teacher/leave/batch-approve', payload)
        .then(response => {
          if (response.data.success == true) {
            this.$bvModal.hide('modal-1');
            this.searchSelectedCb = [];
            this.selectedCb = [];
            this.selected_leave_type = null;
            this.checkAll = false;
            this.$notification.success("Batch Approvals Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.getLeave();
          }
        })
        .catch(error => {
          let errors = error.response
            if (errors && errors.status == 422) {
              const errorObj = errors.data.errors;
              const firstKey = Object.keys(errorObj)[0];
              const firstMessage = errorObj[firstKey][0];
              this.$notification.error(firstMessage, {
                timer: 3,
                position: "bottomCenter"
              });
          }
          this.$bvModal.hide('modal-1');
        });
    },
  },

  watch: {
    'leaveData.data': {
      handler() {
        if (this.checkAll) {
          this.syncCurrentPageSelection();
        }
      },
      deep: true
    }
  },

  mounted() {
    this.isLoading = true;
    this.getLeave();
  },
};
